import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//Import formik validation
import { Spinner } from "reactstrap";

//Import Images
import house_icon from "../../assets/images/auth_home_icon.png";
import config from "../../config";
import { toast } from "react-toastify";
import { showErrorToast, showSuccessToast } from "../utils";

const ForgetPassword = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [email, setEmail] = useState("");

    const clearError = () => {
        setError("");
    };

    useEffect(clearError);

    // validation

    const handleResetPasswod = async (e) => {
        e.preventDefault();
        if (!email) {
            setError("Please enter email");
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(`${config.get("API_URL")}/user/forgot-passwd`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                body: JSON.stringify({
                    email: email,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setEmail("");
                showSuccessToast(data?.message);
                navigate("/reset-password", { state: { email: email } });
            } else {
                showErrorToast(data.detail);
                console.error("Error:", data.detail);
            }
        } catch (error) {
            console.error("Error:", error);
        }

        setLoading(false);
    };

    document.title = `Forgot Password | ${config.get("COMPANY_NAME")}`;

    return (
        <div className="auth-main-wrapper">
            <div
                className="md:tw-bg-none tw-bg-center tw-bg-cover tw-w-full tw-h-full tw-flex tw-justify-between max-sm:tw-overflow-y-scroll"
                style={{ backgroundImage: `url(${house_icon})` }}
            >
                <div
                    style={{ backgroundImage: `url(${house_icon})` }}
                    className="max-sm:tw-hidden tw-relative tw-bg-center tw-bg-cover tw-w-full tw-m-2 "
                >
                    <div className="tw-absolute tw-inset-0 tw-bg-black tw-opacity-30"></div>

                    <div className="tw-absolute tw-top-[40px] tw-left-[30px] tw-flex tw-gap-2 tw-z-10">
                        <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/5c704c298b9ced9c12fdf92061da095dec0b48ab751d0dab56ea704d9d9b3733?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                            alt="AiRE BROKERS logo"
                            className="logo tw-w-[35px] tw-h-[35px]"
                        />
                        <span className={`brandName tw-text-[16px] `}>{config.get("COMPANY_NAME")}</span>
                    </div>
                </div>

                <div className="tw-h-full  max-sm:tw-h-fit tw-w-full tw-self-end tw-pb-[70px] md:tw-pb-0 max-sm:tw-text-white max-sm:tw-bg-blur_background max-sm:tw-backdrop-blur-lg max-sm:tw-rounded-tl-[40px] max-sm:tw-rounded-tr-[40px]  md:tw-px-10 max-sm:tw-px-5  max-sm:tw-mt-52 tw-flex tw-overflow-y-auto tw-justify-center tw-z-10 ">
                    <div className="md:tw-max-w-[526px] 2xl:tw-max-w-[721px] tw-h-full tw-items-center  tw-flex tw-justify-center tw-pt-5  tw-w-full max-sm:tw-mt-10 max-sm:tw-mb-3">
                        <div className="tw-flex tw-flex-col tw-gap-2  2xl:tw-gap-5 ">
                            <div className=" tw-flex tw-flex-col tw-gap-[10px]">
                                <h1 className="tw-text-[36px] tw-font-semibold tw-text-center 2xl:tw-text-[50px] max-sm:tw-text-[24px] ">
                                    Forgot password
                                </h1>
                                <p className="tw-text-[16px] tw-text-center 2xl:tw-text-[20px] md:tw-text-semi_dark_text max-sm:tw-font-thin">
                                    Enter your email for the verification proccess, we will send 6 digits code to your email.
                                </p>
                            </div>

                            <form onSubmit={handleResetPasswod} className="tw-mt-5 ">
                                <div className="tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                    <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Email address</span>
                                    <input
                                        type="email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Email Address"
                                        className="tw-px-3 tw-py-3 tw-bg-background_color max-sm:tw-bg-transparent tw-w-full tw-placeholder-placeholder_color tw-outline-none tw-rounded-[10px] tw-h-[50px] tw-border tw-border-border_color 2xl:tw-text-[22px] max-sm:tw-text-white"
                                    />
                                </div>
                                <div className="tw-py-2 tw-text-center ">
                                    Know your password?{" "}
                                    <span onClick={() => navigate("/login")} className="tw-text-primary hover:tw-cursor-pointer">
                                        Sign in
                                    </span>
                                </div>
                                <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-2 md:tw-gap-4 md:tw-mt-5 md:tw-items-center tw-justify-center">
                                    <button
                                        type="submit"
                                        // onClick={handleResetPasswod}
                                        className="tw-bg-primary tw-border-none tw-text-white  tw-p-3 tw-rounded-md 2xl:tw-text-[18px] tw-px-10"
                                        disabled={loading ? true : false}
                                    >
                                        {loading ? <Spinner size="sm" color="light" /> : "Continue"}
                                    </button>
                                    <button
                                        onClick={() => window.history.back()}
                                        className="tw-border-primary tw-border tw-text-primary  tw-p-3 tw-rounded-md 2xl:tw-text-[18px] tw-px-10"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgetPassword;
